import styled from "@emotion/styled"

const StyledContainer = styled.div<{ paddingMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  z-index: 5;
  width: 100% !important;
  padding: ${(p) => p.paddingMobile && "0 16px"};
  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 1280px;
    padding: 0 88px;
    margin: auto;
  }
  ${({ theme }) => theme.breakpoints.up("xl")} {
    max-width: 1920px;
    padding: 0 240px;
    margin: auto;
  }
`

type Props = {
  children: React.ReactNode
  paddingMobile?: boolean
}

export default function Container({ children, paddingMobile }: Props) {
  return (
    <StyledContainer paddingMobile={paddingMobile}>{children}</StyledContainer>
  )
}
